
import React from "react";
import { Link } from "react-router-dom";

const AutonomousCybercrimeSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4 md:mb-6 text-gray-900">
            Cybercrime Is Now Autonomous, <span className="text-[#8932c8]">Is Your Defense?</span>
          </h2>
          
          <div className="space-y-6 md:space-y-8 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-8 md:mb-12">
            <p className="max-w-3xl mx-auto">
              AI-driven cybercrime isn't speculative anymore - it's operational. Attackers are deploying 
              agentic AI that mimics your users, adapts to your defenses, and moves faster than your team can respond.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 my-8 md:my-12">
              <div className="bg-white rounded-lg p-4 md:p-6 shadow-sm border border-gray-100">
                <p className="text-base sm:text-lg md:text-xl font-semibold text-gray-900">
                  You don't need more dashboards.
                </p>
              </div>
              <div className="bg-gradient-to-r from-[#8932c8]/5 to-[#8932c8]/10 rounded-lg p-4 md:p-6 shadow-sm border border-[#8932c8]/20">
                <p className="text-base sm:text-lg md:text-xl font-semibold text-[#8932c8]">
                  You need an intelligent agent on your side.
                </p>
              </div>
            </div>
            
            <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto">
              <span className="font-semibold text-[#8932c8]">AuraXP™ by Spharaka</span> is built for this moment. 
              It acts as an autonomous teammate - detecting, investigating, and neutralizing threats in real time, 
              across your entire digital surface.
            </p>
            
            <div className="bg-gray-50 rounded-lg p-4 md:p-6 border-l-4 border-[#8932c8] mt-6 md:mt-8">
              <p className="text-base sm:text-lg md:text-xl font-semibold text-gray-900">
                Because in a world of machine-speed threats, the only winning move is a machine-speed defense.
              </p>
            </div>
          </div>
          
          <div className="mt-8 md:mt-12">
            <Link to="/products/auraxp" className="inline-block bg-[#8932c8] hover:bg-[#7a2cb3] text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold text-sm md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
              See how AuraXP™ is helping CISOs stay ahead
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutonomousCybercrimeSection;
